import { useEffect, useRef, useState } from "react";

import { SparklineCell } from "@similarweb/pro-logic-components";

import { SparklineZoneOverlay, type SparklineZoneOverlayProps } from "./SparklineZoneOverlay";

export const ZonedSparklineCell = ({
    data,
    height,
    min,
    zoneColor,
    zoneStartIndex,
}: Omit<SparklineZoneOverlayProps, "width">) => {
    const wrapperRef = useRef<HTMLDivElement>(null);

    const [containerWidth, setContainerWidth] = useState(0);

    useEffect(() => {
        if (wrapperRef.current) {
            setContainerWidth(wrapperRef.current.getBoundingClientRect().width);
        }
    }, []);

    return (
        <div
            ref={wrapperRef}
            style={{ position: "relative", overflow: "hidden", width: "100%" }}
        >
            <SparklineCell
                type="area"
                data={data as number[]}
                height={height}
                min={min}
            />

            {containerWidth > 0 ? (
                <SparklineZoneOverlay
                    data={data}
                    zoneStartIndex={zoneStartIndex}
                    zoneColor={zoneColor}
                    width={containerWidth}
                    height={height}
                    min={min}
                />
            ) : null}
        </div>
    );
};
